import { Box, InputAdornment, TextField, Typography } from '@mui/material'
import { ISearchInput } from './types'
import SearchIcon from '@mui/icons-material/Search'

const SearchInput: React.FC<ISearchInput> = ({
  label,
  value,
  onValueChange,
  placeholder = 'Search',
}) => {
  return (
    <Box sx={{ width: '100%' }}>
      <Typography sx={{ typography: 'labelBold', marginBottom: '.7rem' }}>{label}</Typography>

      <TextField
        value={value}
        onChange={onValueChange}
        type='text'
        id='username-input'
        aria-describedby='username-helper-text'
        fullWidth
        variant='standard'
        placeholder={placeholder}
        sx={{ input: { paddingLeft: '4rem' } }}
        InputProps={{
          startAdornment: (
            <InputAdornment position='start' sx={{ margin: 0 }}>
              <SearchIcon
                sx={{
                  position: 'absolute',
                  left: '1rem',
                  top: '1rem',
                }}
              />
            </InputAdornment>
          ),
        }}
      />
    </Box>
  )
}

export default SearchInput
